export default __webpack_public_path__ + "static/media/ads-v3-bg.8bb29c95.jpg";